import { useTheme } from "@/context/ThemeContext";
import { SITE } from "@/data/site";
import { asset, assetSet } from "@/lib/asset";

// Déclinaison dorée des visuels de marque, utilisée uniquement en mode Or.
const GOLD = {
  logoFull: "/logo-virtualpeek-or-384.webp",
  logoFullSrcSet: "/logo-virtualpeek-or-256.webp 256w, /logo-virtualpeek-or-384.webp 384w, /logo-virtualpeek-or-640.webp 640w",
  mascotHero: "/mascot-or.webp",
  mascotHeroSm: "/mascot-or-sm.webp",
};

export function useBrand() {
  const { theme } = useTheme();
  const gold = theme === "gold";
  return {
    gold,
    logoFull: asset(gold ? GOLD.logoFull : SITE.logoFull),
    logoFullSrcSet: assetSet(gold
      ? GOLD.logoFullSrcSet
      : "/logo-virtualpeek-256.webp 256w, /logo-virtualpeek-384.webp 384w, /logo-virtualpeek.webp 624w"),
    logoClass: gold ? "object-contain object-left" : "object-cover object-center",
    logoStyle: gold ? undefined : { objectPosition: "center 45%" },
    mascotHero: asset(gold ? GOLD.mascotHero : SITE.mascotHero),
    mascotHeroSrcSet: assetSet(gold
      ? `${GOLD.mascotHeroSm} 320w, /mascot-or-480.webp 480w, ${GOLD.mascotHero} 900w`
      : "/mascot-hero-sm.webp 320w, /mascot-hero-480.webp 480w, /mascot-hero.webp 900w"),
  };
}
